// 监控Modal
// 对接的监控类型---JD:九鼎 HaiKang: 海康

import React, { useState, useEffect } from 'react'
import { Modal } from "antd";
import { stationgisApi, stationflowchart, dictApi } from '@api/newApi';
import JDVideoHook from "./JDVideo";
import MediaComponent from "./media";
import HaiKangVideo from "./HaiKangVideo";
import "../style.scss";
const { WSS_HAIKANG_BASE } = window.globalConfig;

export default ({ name, id, setVisible }) => {

  const videoHook = JDVideoHook();
  const [dict, setDict] = useState({});
  const [pre, setPre] = useState(4);
  const [boxes, setBoxLists] = useState([]);
  const [playerList, setPlayerList] = useState([]); //JD
  const [playerList_HaiKang, setPlayerList_HaiKang] = useState([]); //海康
  const [type, setType] = useState('HangKang')
  // 视频弹窗，右侧视频宽度
  const [styleMedia, setStyleMedia] = useState({
    width: 260,
    height: 196,
    widthGrid: "100%",
  });
  // 视频弹窗，左侧视频项宽度
  const [styleMediaRight, setStyleMediaRight] = useState({
    width: 672,
    height: 504,
    widthGrid: "100%",
  });

  useEffect(() => {
    !boxes.length && boxesList();
    !videoHook.websocket && videoHook.initWebSocket();
    findCameraByStationId();
    // selectType()
  }, [name]);

  useEffect(() => {
    // let playerList_jd = playerList.filter((item) => item.video_type == 'JD');
    // console.log(playerList, playerList_jd, 'dddddddd')
    // playerList_jd.length && videoHook.getPlayerDom(playerList_jd);
  }, [playerList]);

  const selectType = () => {
    switch (type) {
      case 'JD':
        videoHook.initWebSocket();
        boxesList();
        findCameraByStationId();
        break;
      case 'HangKang':
        selectWithClassifyKey();
        break;
    }
  }
  /**
   * 获取摄像头列表
   * @param {*} {}
   * @returns
   */
  const findCameraByStationId = () => {
    stationflowchart.findCameraByStationId({ id }).then((res) => {
      if (res.status == 0) {
        const data = res.message && JSON.parse(res.message);
        let list = [];
        data.forEach((item) => {
          item.SXT && item.SXT.map(mm => {
            let obj = {
              cameraId: mm.CCD,
              rtspUrl: mm.URL,
              studioId: item.VGW,
              video_type: 'JD'
            }
            obj.cameraId && list.push(obj);
          })
        });
        boxesList(list.length);
        setPlayerList(() => {
          return [...list];
        });
        if (JSON.stringify(dict) == '{}') {
          selectWithClassifyKey(list);
        } else {
          listCamerasByRegion(dict, list)
        }
      }
    });
  };

  /**
   * @description 字典表
   */
  const selectWithClassifyKey = (list) => {
    dictApi.selectWithClassifyKey({ classifyKey: 'stationRegionCode' }).then((res) => {
      if (res.status == 0) {
        let obj = {};
        res.data.map((item) => {
          obj[item.disName] = item.value;
        })
        setDict(obj);
        listCamerasByRegion(obj, list);
      }
    })
  }
  /**
   * 获取摄像头列表---海康
   * @param {*} {}
   * @returns
   */
  const listCamerasByRegion = (obj, list) => {
    // console.log(obj, name, 'xxxxxxxx')
    const code = obj[name];
    code &&
      stationflowchart.listCamerasByRegion({ pageNo: 1, pageSize: 1000, regionIndexCode: code }).then((res) => {
        if (res.status == 0) {
          const data = res.data.data;
          let d = [];
          let promises = data.map(async (item) => {
            const promise = await stationflowchart.getPreviewURLs({ cameraIndexCode: item.cameraIndexCode, protocol: 'wss' }).then((res1) => {
              if (res1.status == 0 && res1.data.url) {
                const url = res1.data.url.replace(/wss:\/\/([0-9]+.)+/, WSS_HAIKANG_BASE)
                d.push({ url: url, video_type: 'HaiKang' });
              }
            })
            return promise;
          })
          Promise.all(promises).then(() => {
            console.log(333, d, list, d, [...list, ...d]);
            boxesList(list.length + d.length);
            setPlayerList(() => {
              return [...list, ...d];
            });
          })
        }
      });
  };
  const boxesList = (length = 0) => {
    let boxes = [];
    let len = pre - length;
    for (let i = 0; i < len; i++) {
      boxes.push(i);
    }
    setBoxLists(boxes);
  };

  const setComponent = (item, index, _styleMedia = styleMedia) => {
    let com = '';
    switch (item.video_type) {
      case 'JD':
        com = <MediaComponent
          styleMedia={_styleMedia}
          key={index}
          mediaProps={item}
        />
        break;
      case 'HaiKang':
        com = <HaiKangVideo
          playURL={item.url}
          id={`playerHangkang_minitor_${index}`}
          key={index}
          styleMedia={_styleMedia}
        />
        break;
    }
    return com;
  }
  return (
    <Modal
      title="摄像头"
      width={944}
      centered
      className="camera-modal"
      destroyOnClose
      open={true}
      onOk={() => setVisible(false)}
      onCancel={() => {
        setVisible(false);
      }}
    >
      <div className="main-content media-container">
        <div className="left">
          {playerList &&
            playerList.length > 0 &&
            playerList.map((item, index) => {
              if (index != 0) {
                return setComponent(item, index)
              }
            })}
          {boxes.length > 0 &&
            boxes.map((item, index) => {
              return (
                <div
                  className="media-item blank"
                  key={index}
                  style={{ ...styleMedia, width: styleMedia.widthGrid }}
                >
                  <img src={require("../img/33.png")} alt="" />
                </div>
              );
            })}
        </div>
        <div className="right">
          {
            playerList &&
            playerList.length > 0 &&
            playerList.map((item, index) => {
              if (index == 1) {
                return setComponent(item, index, styleMediaRight)
              }
            })
          }
          {playerList.length == 0 && (
            <div
              className="media-item blank"
              style={{
                ...styleMediaRight,
                width: styleMediaRight.widthGrid,
              }}
            >
              <img src={require("../img/33.png")} alt="" />
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}
